import PropTypes from "prop-types"
import React from "react"
import styled from "styled-components"
import { GatsbyImage } from "gatsby-plugin-image"

const StyledGatsbyImageWrapper = styled.div`
  width: 100%;
  height: 100%;
  max-height: 100%;

  .gatsby-image-wrapper {
    width: 100%;
    height: 100%;
    max-height: 100%;
  }

  ${props =>
    props.centered &&
    `
    max-width: 71rem;
    margin: 0 auto;

    .gatsby-image-wrapper {
      position: relative;

      height: auto;
      padding-bottom: 56.25%;

      picture img{
        position: absolute !important;
        top:0;
        left: 0;
        height: 100%;
        object-fit: cover !important;
        margin: 0;
      }
    }
  `}
`

const GatsbyImageBanner = ({ image, centered, alt }) => {
  return (
    <StyledGatsbyImageWrapper centered={centered}>
      <GatsbyImage image={image} alt={alt} />
    </StyledGatsbyImageWrapper>
  )
}

GatsbyImageBanner.propTypes = {
  image: PropTypes.object,
  alt: PropTypes.string,
  centered: PropTypes.bool,
}

export default GatsbyImageBanner
